module.exports = __webpack_public_path__ + "static/cover-d9ca905b811593d0467d06bcee3dd444.webp";